exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".logo{background:url(/ng/assets/images/old/new_logo_black.png) no-repeat;width:185px;height:55px;background-size:cover;display:inline-block;text-decoration:none!important}.logo-bm{width:134px;margin-top:10px}.logo-bm a{display:block}", "", {"version":3,"sources":["/srv/projects/jsapp/src/app/core/header/header.component.css"],"names":[],"mappings":"AAAA,MACE,mEAAmE,YACtD,YACA,sBACU,qBACD,8BACW,CAClC,SAGA,YAAa,eACI,CACjB,WAEA,aAAe,CACf","file":"header.component.css","sourcesContent":[".logo{\n  background: url('/assets/images/old/new_logo_black.png') no-repeat;\n  width: 185px;\n  height: 55px;\n  background-size: cover;\n  display: inline-block;\n  text-decoration: none !important;\n}\n\n.logo-bm {\n\twidth: 134px;\n\tmargin-top: 10px;\n}\n.logo-bm a {\n\tdisplay: block;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/core/header/header.component.css
// module id = Hyz2
// module chunks = 6